(function () {
	'use strict';

	// First-touch attribution: classifies how this visitor arrived (from UTM
	// params, falling back to document.referrer) into one of a small fixed
	// set of categories the backend accepts (see KNOWN_SOURCES in
	// lib/proxy-handlers/track-source.ts), stores it in a cookie the first
	// time only, then reports it to the backend once this visitor is
	// actually logged in — covering both a brand-new Free registration
	// (auto-logged-in right after /account/register) and a Basic/Pro
	// subscriber landing back on My Library post-checkout, with the same
	// code path.
	var SOURCE_COOKIE = 'mb_traffic_source';
	var REFERRER_COOKIE = 'mb_traffic_referrer';
	var REPORTED_COOKIE = 'mb_traffic_source_reported';
	var COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days

	function getCookie(name) {
		var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
		return match ? decodeURIComponent(match[1]) : null;
	}

	function setCookie(name, value, maxAgeSeconds) {
		document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + maxAgeSeconds + '; path=/; SameSite=Lax';
	}

	function classifySource() {
		var params = new URLSearchParams(window.location.search);
		var utmSource = (params.get('utm_source') || '').toLowerCase();
		var utmMedium = (params.get('utm_medium') || '').toLowerCase();

		if (utmSource) {
			var isPaid = /cpc|paid|ads|ppc/.test(utmMedium);
			if (utmSource.indexOf('google') !== -1) return 'Google';
			if (utmSource.indexOf('instagram') !== -1 || utmSource === 'ig') return 'Instagram';
			if (utmSource.indexOf('facebook') !== -1 || utmSource === 'fb' || utmSource.indexOf('meta') !== -1) {
				return isPaid ? 'Facebook Ads' : 'Instagram';
			}
			if (isPaid) return 'Facebook Ads';
			return 'Referral';
		}

		var referrer = document.referrer;
		if (!referrer) return 'Direct';

		var referrerHost = '';
		try {
			referrerHost = new URL(referrer).hostname.toLowerCase();
		} catch (e) {
			return 'Direct';
		}

		if (referrerHost.indexOf('google.') !== -1) return 'Google';
		if (referrerHost.indexOf('instagram.com') !== -1) return 'Instagram';
		if (referrerHost.indexOf('facebook.com') !== -1 || referrerHost.indexOf('fb.com') !== -1) return 'Instagram';
		if (referrerHost.indexOf(window.location.hostname) !== -1) return null; // internal navigation, not a new visit
		return 'Referral';
	}

	// First-touch: only set once per visitor, never overwritten by a later
	// visit through a different channel. The raw referrer is captured
	// alongside the classification (only meaningful for "Referral") since by
	// the time the report fires — possibly on a later page load — document.
	// referrer would reflect that later page's own referrer, not this first one.
	if (!getCookie(SOURCE_COOKIE)) {
		var classified = classifySource();
		if (classified) {
			setCookie(SOURCE_COOKIE, classified, COOKIE_MAX_AGE);
			if (classified === 'Referral' && document.referrer) {
				setCookie(REFERRER_COOKIE, document.referrer, COOKIE_MAX_AGE);
			}
		}
	}

	// Report once the visitor is actually a known logged-in customer —
	// nothing to attribute before that. window.theme.settings.customer_id is
	// rendered site-wide in layout/theme.liquid (unlike data-customer-id,
	// which only exists on the account/My Library pages), so this fires on
	// whichever page the customer happens to land on first while logged in.
	var customerId = window.theme && window.theme.settings ? window.theme.settings.customer_id : null;
	var source = getCookie(SOURCE_COOKIE);
	if (customerId && source && !getCookie(REPORTED_COOKIE)) {
		var url = '/apps/mockup-downloads/track-source?source=' + encodeURIComponent(source) + '&customer_id=' + encodeURIComponent(customerId);
		var referrer = getCookie(REFERRER_COOKIE);
		if (referrer) url += '&referrer=' + encodeURIComponent(referrer);
		fetch(url, { credentials: 'same-origin' })
			.then(function () {
				setCookie(REPORTED_COOKIE, '1', COOKIE_MAX_AGE);
			})
			.catch(function () {
				// Best-effort — try again on the next page view.
			});
	}
})();
